import { Column, ColumnContainer } from "@jsq/ds/layouts";
import { CoverageView, UploadRail } from "@jsq/fay-components";
import { globalEnv } from "~/global-env";
import * as styles from "../styles_vanilla.css";

type ArenaSurfaceProps = {
  arenaId: number;
};

/**
 * The arena-scoped half of the Fay page. `arenaId` arrives as a prop rather than being read
 * from context, so the package components that mount here take the same arena the route names.
 *
 * `UploadRail` is the whole ingestion and classification surface, not just the drop zone: it owns
 * the batch list, the ingestion slideout, and the classification confirm screen with its modals.
 * `CoverageView` is likewise the whole coverage surface — the filter row, the grid, and the package
 * detail slideout its cells open. Composing either from their parts would fork the flow away from
 * GPX, so both go in whole.
 */
export const ArenaSurface = ({ arenaId }: ArenaSurfaceProps) => {
  return (
    <div className={styles.pageContainer}>
      <div className={styles.contentContainer}>
        {/* The content container already pads, so the columns don't add their own top padding. */}
        <ColumnContainer hasTopPadding={false} className={styles.columnContainer}>
          <Column size="fluid">
            {/* GPX serves Fay at the bare route, so the package's own deep links default to
                sitting directly under it. Canopy serves a surface per arena, so it passes the
                arena-scoped prefix instead: opening a package then nests under the arena rather
                than navigating out of it, and a shared link still names the arena to load. */}
            <CoverageView
              arenaId={arenaId}
              routeBase={`${globalEnv.fayAIRoute}/arena/${arenaId}`}
            />
          </Column>
          <Column size="sm">
            <UploadRail arenaId={arenaId} />
          </Column>
        </ColumnContainer>
      </div>
    </div>
  );
};
